import { UnclaimedMoneyItem, UnclaimedSearchResult } from "@/types/unclaimed";
import { POST } from ".";

export type SubmitUnclaimedSearchRequest = {
  names: {
    first: string;
    last: string;
  }[];
  addresses: {
    city: string;
    street: string;
    zip: string;
    state: string;
  }[];
};

const UnclaimedServices = {
  /**
   * Submit unclaimed search
   * @returns Promise<ApiResponse<null>>
   */
  submitUnclaimedSearch: async (request: SubmitUnclaimedSearchRequest) => {
    return await POST<null>(`/unclaimed-property-search/create`, request);
  },
  getCurrentUnclaimedSearch: async () => {
    return await POST<
      SubmitUnclaimedSearchRequest & { hasActiveSearch: boolean }
    >(`/unclaimed-property-search/addresses`);
  },
  getUnclaimedSearch: async () => {
    return await POST<{ result: UnclaimedSearchResult }>(
      `/unclaimed-property-search/get`
    );
  },
  triggerUnclaimedSearch: async (
    request: SubmitUnclaimedSearchRequest & { userId: string }
  ) => {
    return await POST<null>(`/unclaimed-property-search/trigger`, request);
  },
  addClaimToSheet: async (data: UnclaimedMoneyItem) => {
    return await POST<null>(`/claim/add-to-sheet`, data);
  },
};

export default UnclaimedServices;
